import { Stack } from '../../design-system/stack/stack';
import Header from '../layout/header';
import { InvoicePayPageInnerWrapper } from './invoice-pay-page-inner-wrapper';

export const InvoicePayPageOuterWrapper = () => {
  return (
    <Stack align="stretch" className="min-h-screen p-2.5">
      <Stack align="stretch" className="flex-1 overflow-clip rounded-lg bg-white">
        <div className="overflow-clip">
          <Header />
        </div>

        <InvoicePayPageInnerWrapper />
      </Stack>
    </Stack>
  );
};
